import { getAllPaymentConfig } from 'redux/payment-configuration/saga/fetchAllPaymentConfig';
import {
  getPaystackConfig,
  getRemitaConfig,
  getInterswitchConfig,
  getNabrollConfig
} from 'redux/payment-configuration/saga/fetchEachPaymentConfig';
import {onUpdatePaymentConfig} from 'redux/payment-configuration/saga/updatePaymentConfig';
import { onImportPaymentConfig } from 'redux/payment-configuration/saga/importPaymentConfig';
import { onDeletePaymentConfig } from 'redux/payment-configuration/saga/deletePaymentConfig';
import { onUpdatePlatformChargeStatus } from './updatePaylogChargeStatus';

import { call, all } from 'redux-saga/effects';

export default function* groupsSaga() {
  yield all([
    call(getAllPaymentConfig),
    call(getPaystackConfig),
    call(getNabrollConfig),
    call(getRemitaConfig),
    call(getInterswitchConfig),
    call(onImportPaymentConfig),
    call(onDeletePaymentConfig),
    call(onUpdatePaymentConfig),
    call(onUpdatePlatformChargeStatus),
  ]);
}
